import type { ProfessionalTeamMember } from '@modules/professional/page/loaders/overview-page-loader.server';
import type { TeamMemberOverlayContact } from '~/ui-rocco/pages/detail-shared/TeamMemberOverlay';

/**
 * The contacts a profile's team-member overlay offers: those the record holds
 * and the professional has not hidden, as the About tab's dialog shows them.
 */
export const teamMemberContact = (
    member: ProfessionalTeamMember,
    professionalId: number,
): TeamMemberOverlayContact => ({
    phone: member.hidePhone ? undefined : member.phone || undefined,
    email: member.hideEmail ? undefined : member.email || undefined,
    linkedInLink: member.hideLinkedInLink
        ? undefined
        : member.linkedInLink || undefined,
    website: member.website,
    professionalId,
});
